import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
const columns = [{
  heading: 'For guests',
  links: [{
    to: '/discover',
    label: 'Find a chef'
  }, {
    to: '/how-it-works',
    label: 'How it works'
  }, {
    to: '/app/bookings',
    label: 'My bookings'
  }, {
    to: '/app/support',
    label: 'Get help'
  }]
}, {
  heading: 'For chefs',
  links: [{
    to: '/for-chefs',
    label: 'Cook with Pan & Apron'
  }, {
    to: '/chef/onboarding',
    label: 'Build a listing'
  }, {
    to: '/legal/chef-terms',
    label: 'Chef terms'
  }, {
    to: '/chef/earnings',
    label: 'Payouts'
  }]
}, {
  heading: 'Company',
  links: [{
    to: '/contact',
    label: 'Contact'
  }, {
    to: '/legal/terms',
    label: 'Terms of service'
  }, {
    to: '/legal/privacy',
    label: 'Privacy'
  }, {
    to: '/legal/cookies',
    label: 'Cookies'
  }]
}, {
  heading: 'Safety',
  links: [{
    to: '/legal/allergens',
    label: 'Allergen & food safety'
  }, {
    to: '/legal/waiver',
    label: 'Liability waiver'
  }, {
    to: '/legal/cancellations',
    label: 'Cancellation policy'
  }, {
    to: '/legal/disclaimers',
    label: 'Disclaimers'
  }]
}];
export function PublicFooter() {
  return <footer className="border-t border-hairline bg-oat" data-id="element-856" data-mp="o6q35s4w71rq">
      <div className="mx-auto max-w-shell px-5 py-14 lg:px-8" data-id="element-857" data-mp="k77j0ykwaupy">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]" data-id="element-858" data-mp="k4v5qyq318j8">
          <div data-id="element-859" data-mp="f960qfvamzfj">
            <Logo data-id="element-860" data-mp="f5i9jndbmp3z" />
            <p className="mt-3 max-w-[34ch] text-sm text-ink-2" data-id="element-861" data-mp="a8i3hcgh1mcv">
              Private chefs who cook in your kitchen, or cook in theirs and deliver. Real menus, itemized quotes.
            </p>
          </div>
          {columns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-862" data-mp="1950n2murw14">
              <h2 className="text-[12px] font-semibold uppercase tracking-[0.06em] text-ink-3" data-id="element-863" data-mp="1znyaal6xavzl">{column.heading}</h2>
              <ul className="mt-3 space-y-2" data-id="element-864" data-mp="1vmw93ytg49uz">
                {column.links.map(link => <li key={link.to + link.label} data-id="element-865" data-mp="3p4bsd265i1ay">
                    <Link to={link.to} className="text-sm text-ink-2 transition-colors duration-150 ease-out hover:text-ink" data-id="element-866" data-mp="3p2qub2kmo08c">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-hairline pt-6 text-[13px] text-ink-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-867" data-mp="bqqjxtb6d3pp">
          <p data-id="element-868" data-mp="gme4fvepp8ov">© 2026 Pan &amp; Apron Co., Ltd. Chefs are independent operators, not employees.</p>
          <p data-id="element-869" data-mp="2rbpyjvsub0g">Prototype — no payments are processed.</p>
        </div>
      </div>
    </footer>;
}